/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconCake from '../../../../../../Icon/IconCake';
import IconDomain from '../../../../../../Icon/IconDomain';
import IconGroup from '../../../../../../Icon/IconGroup';
import IconGroupAdd from '../../../../../../Icon/IconGroupAdd';
import IconLocationCity from '../../../../../../Icon/IconLocationCity';
import IconMood from '../../../../../../Icon/IconMood';
import IconMoodBad from '../../../../../../Icon/IconMoodBad';
import IconNotifications from '../../../../../../Icon/IconNotifications';
import IconNotificationsActive from '../../../../../../Icon/IconNotificationsActive';
import IconNotificationsNone from '../../../../../../Icon/IconNotificationsNone';
import IconNotificationsOff from '../../../../../../Icon/IconNotificationsOff';
import IconNotificationsPaused from '../../../../../../Icon/IconNotificationsPaused';
import IconPages from '../../../../../../Icon/IconPages';
import IconPartyMode from '../../../../../../Icon/IconPartyMode';
import IconPeople from '../../../../../../Icon/IconPeople';
import IconPeopleOutline from '../../../../../../Icon/IconPeopleOutline';
import IconPerson from '../../../../../../Icon/IconPerson';
import IconPersonAdd from '../../../../../../Icon/IconPersonAdd';
import IconPersonOutline from '../../../../../../Icon/IconPersonOutline';
import IconPlusOne from '../../../../../../Icon/IconPlusOne';
import IconPoll from '../../../../../../Icon/IconPoll';
import IconPublic from '../../../../../../Icon/IconPublic';
import IconSchool from '../../../../../../Icon/IconSchool';
import IconSentimentDissatisfied from '../../../../../../Icon/IconSentimentDissatisfied';
import IconSentimentNeutral from '../../../../../../Icon/IconSentimentNeutral';
import IconSentimentSatisfied from '../../../../../../Icon/IconSentimentSatisfied';
import IconSentimentVeryDissatisfied from '../../../../../../Icon/IconSentimentVeryDissatisfied';
import IconSentimentVerySatisfied from '../../../../../../Icon/IconSentimentVerySatisfied';
import IconShare from '../../../../../../Icon/IconShare';
import IconWhatshot from '../../../../../../Icon/IconWhatshot';

export default function SocialIcons() {
  return (
    <div>
      <CategoryHeader>social</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconCake size="32"/>
          <FigCaption>
            IconCake
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDomain size="32"/>
          <FigCaption>
            IconDomain
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGroup size="32"/>
          <FigCaption>
            IconGroup
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGroupAdd size="32"/>
          <FigCaption>
            IconGroupAdd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocationCity size="32"/>
          <FigCaption>
            IconLocationCity
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMood size="32"/>
          <FigCaption>
            IconMood
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMoodBad size="32"/>
          <FigCaption>
            IconMoodBad
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNotifications size="32"/>
          <FigCaption>
            IconNotifications
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNotificationsActive size="32"/>
          <FigCaption>
            IconNotificationsActive
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNotificationsNone size="32"/>
          <FigCaption>
            IconNotificationsNone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNotificationsOff size="32"/>
          <FigCaption>
            IconNotificationsOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNotificationsPaused size="32"/>
          <FigCaption>
            IconNotificationsPaused
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPages size="32"/>
          <FigCaption>
            IconPages
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPartyMode size="32"/>
          <FigCaption>
            IconPartyMode
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPeople size="32"/>
          <FigCaption>
            IconPeople
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPeopleOutline size="32"/>
          <FigCaption>
            IconPeopleOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPerson size="32"/>
          <FigCaption>
            IconPerson
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPersonAdd size="32"/>
          <FigCaption>
            IconPersonAdd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPersonOutline size="32"/>
          <FigCaption>
            IconPersonOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPlusOne size="32"/>
          <FigCaption>
            IconPlusOne
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPoll size="32"/>
          <FigCaption>
            IconPoll
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPublic size="32"/>
          <FigCaption>
            IconPublic
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSchool size="32"/>
          <FigCaption>
            IconSchool
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSentimentDissatisfied size="32"/>
          <FigCaption>
            IconSentimentDissatisfied
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSentimentNeutral size="32"/>
          <FigCaption>
            IconSentimentNeutral
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSentimentSatisfied size="32"/>
          <FigCaption>
            IconSentimentSatisfied
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSentimentVeryDissatisfied size="32"/>
          <FigCaption>
            IconSentimentVeryDissatisfied
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSentimentVerySatisfied size="32"/>
          <FigCaption>
            IconSentimentVerySatisfied
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconShare size="32"/>
          <FigCaption>
            IconShare
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWhatshot size="32"/>
          <FigCaption>
            IconWhatshot
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/SocialIcons.js